export const PRINICIPLE_ENTITIES_GET = "contentlibrary/principle_entity";
export const FILE_TYPES_GET = "contentlibrary/filetype";
export const CONTENT_LIST_POST = "contentlibrary/list";
export const CONTENTS_BY_FILE_TYPE = "contentlibrary/filetype/count";
export const CONTENT_DETAILS_GET = "contentlibrary/detail/";
export const CONTENTS_BY_BRAND = "contentlibrary/brand/count";
